import { AppSwitch } from '@/ui/switch/AppSwitch';
import classNames from 'classnames';
import { InputSwitchProps } from 'primereact/inputswitch';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

export type FormikSwitchProps = {
  field: {
    name: string;
    value: string;
    onChange: () => void;
    onBlur: () => void;
  };
  form: { touched: Record<string, any>; errors: Record<string, any> };
  label?: string;
  tooltip?: string | ReactNode;
  tooltipId?: string;
  tooltipStyle?: React.CSSProperties;
};

const StyledLabel = styled.label`
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  font-weight: 500;
  margin-bottom: 0 !important;
  margin-left: var(--small-padding) !important;
`;

export const FormikSwitch: React.FC<FormikSwitchProps & InputSwitchProps> = ({
  field,
  form,
  label,
  prefix,
  required,
  className,
  ...rest
}) => (
  <>
    {prefix && (
      <StyledLabel
        htmlFor={field.name}
        className={classNames(
          {
            'p-error': !!form.errors[field.name],
          },
          'mr-2',
        )}
      >
        {prefix}
      </StyledLabel>
    )}
    <AppSwitch
      {...field}
      {...rest}
      checked={!!field.value}
      className={className}
    />
    <StyledLabel
      htmlFor={field.name}
      className={classNames({
        'p-error': !!form.errors[field.name],
      })}
    >
      {label}
      {required ? <span className="red"> *</span> : ''}
    </StyledLabel>
  </>
);
